import * as React from 'react';

import { NumberedList } from '@travelnest/merlin.numbered-list';
import theme from '@travelnest/merlin.theme';
import { BlueButton, BlueLinkButton, HelpFeaturedContainer } from './components';
import { LOGIN_ROUTES } from './constants';

export interface ILoginEmailHelpProps {
	loading: boolean;
	onSubmit: () => void;
}

export const LoginEmailHelp: React.FC<ILoginEmailHelpProps> = ({ loading, onSubmit }) => {

	return <HelpFeaturedContainer>
		<h1>Let's try again</h1>
		<p>Sometimes the email we send can get delayed or be blocked by your email provider.</p>
		<p>Take a moment to check the following:</p>
		<NumberedList list={[
			'Allow a few minutes for your email to be received',
			'Check the spam folder in your emails',
		]}/>
		<p>If the email still hasn't arrived, we can send it again, or you can enter a new email address.</p>
		<div>
			<div>
				<BlueButton
						id="send-new-email"
						loading={loading}
						onClick={() => onSubmit()}
				>Send me a new email</BlueButton>
			</div>
			<div style={{ marginTop: theme.layout.spacing.small }}>
				<BlueLinkButton
					id="use-different-email"
					to={LOGIN_ROUTES.EMAIL}
				>Use a different email address</BlueLinkButton>
			</div>
		</div>
	</HelpFeaturedContainer>;
};
